const Helper = {
  mergeData: (data1, data2) => {
    let data = [];
    if (!data1) return [];
    for (let i = 0; i < data1.length; i++) {
      let obj = {};
      obj = { ...data1[i] };
      if (data2 !== undefined && data2.length > 0) {
        let filtered = data2.filter(
          (e) => e["metric_name"] == data1[i]["metric_name"]
        );

        if (filtered.length > 0) {
          obj["new_benchmark"] = filtered[0]["benchmark"];
          obj["new_fund"] = filtered[0]["fund"];
        } else {
          obj["new_benchmark"] = null;
          obj["new_fund"] = null;
        }
      }

      data.push(obj);
    }
    return data;
  },
  portfolioReturnDataModify: (data) => {
    let rows = [];
    if (!data) return [];
    for (let i in data) {
      let line = data[i];
      let perc = "";
      let gen = 1;
      let metric_name = line.metric_name.toLowerCase();
      if (metric_name === "up" || metric_name === "down") {
        continue;
      }
      if (
        metric_name !== "correlation" &&
        metric_name !== "beta" &&
        metric_name !== "sharpe ratio" &&
        metric_name !== "sortino ratio" &&
        metric_name !== "down months" && 
        metric_name !== "information ratio"
      ) {
        perc = "%";
      }
      if (
        metric_name === "alpha" ||
        metric_name === "annualized return" ||
        metric_name === "annualized vol" ||
        metric_name === "downside deviation"
      ) {
        gen = 100;
      }
      let finalData;
      let fund = 0;
      let benchmark = 0;
      let new_fund = 0;

      if (!line.fund || (line.fund * gen).toFixed(2) == 0.0) fund = "";
      else fund = (line.fund * gen).toFixed(2) + perc;

      if (!line.benchmark || (line.benchmark * gen).toFixed(2) == 0.0)
        benchmark = "";
      else benchmark = (line.benchmark * gen).toFixed(2) + perc;

      if (Object.keys(data[i]).length > 3) {
        if (!line.new_fund || (line.new_fund * gen).toFixed(2) == 0.0)
          new_fund = "";
        else new_fund = (line.new_fund * gen).toFixed(2) + perc;

        finalData = [line.metric_name, fund, benchmark, new_fund];
      } else {
        finalData = [line.metric_name, fund, benchmark];
      }
      rows.push(finalData);
    }

    return rows;
  },
};

export default Helper;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/performance/helper.js